export default "__VITE_ASSET__CYcB0YDH__"